module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-expand-lg "
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": _vm.path || '/rfq',
      "href": "#",
      "id": "test"
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-minimize"
  }, [_c('button', {
    staticClass: "btn btn-success btn-fill btn-round btn-icon d-none d-lg-block",
    attrs: {
      "id": "minimizeSidebar"
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v visible-on-sidebar-regular"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-navicon visible-on-sidebar-mini"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "aria-controls": "navigation-index",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19b155f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 680
// module chunks = 0